const FALLBACK_API_BASE = '/api/v1'

function normalizeApiBaseUrl(raw: unknown): string {
  const base = typeof raw === 'string' ? raw.trim() : ''
  if (!base) return FALLBACK_API_BASE

  // Remove trailing slashes to avoid double slashes.
  const cleaned = base.replace(/\/+$/, '')

  // If env points to an absolute URL (http/https), but the browser origin differs,
  // requests may fail due to CORS or mixed-content (common behind HTTPS + proxy).
  if (cleaned.startsWith('http://') || cleaned.startsWith('https://')) {
    try {
      if (typeof window !== 'undefined') {
        const u = new URL(cleaned)
        if (u.origin !== window.location.origin) return FALLBACK_API_BASE
      }
      return cleaned
    } catch {
      return FALLBACK_API_BASE
    }
  }

  // If env is relative but missing leading slash, fix it.
  if (!cleaned.startsWith('/')) return `/${cleaned}`
  return cleaned
}

export function getApiBaseUrl(): string {
  return normalizeApiBaseUrl((import.meta as any).env?.VITE_API_URL) || FALLBACK_API_BASE
}

